// Journey manifest + resolver, renderer-free; every journey is a lazy loader.
// See .claude/context/journey-resolution.md.
export const DEFAULT_JOURNEY_ID = 'assistant';

export const journeyLoaders = {
  'paint-color-picker': () => import('./paintColorPicker/journey'),
  legacy: () => import('./legacy/journey'),
  [DEFAULT_JOURNEY_ID]: () => import('./Assistant/journey'),
};

/**
 * True if `id` names a registered journey — the default included, it is a loader like any
 * other.
 * @param {string} id
 */
export const isLazyJourney = (id) => Object.prototype.hasOwnProperty.call(journeyLoaders, id);

/**
 * Resolve a journey hint to a registered journeyId. An unknown or missing hint returns
 * `DEFAULT_JOURNEY_ID`. See .claude/context/journeys.md.
 * @param {string} [hint]
 */
export const resolveJourneyId = (hint) => (isLazyJourney(hint) ? hint : DEFAULT_JOURNEY_ID);
